
let changeChat = (state, { payload: { id } }) => {
    state.currentChat = state.chats.find((chat) => chat.id === id);
    localStorage.setItem('currentChatId', state.currentChat.id);
}

export default changeChat;
